var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBrightness = function SvgIconBrightness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1A1F",
    d: "M7.5 3.474V1.013h1v2.461zm4.049 1.68-.686-.686 1.719-1.776.709.72zm.976 3.346v-1h2.462v1zM7.5 14.987v-2.455h1v2.455zm-3.036-9.86-1.772-1.71.726-.702L5.16 4.451zm8.108 8.18-1.71-1.775.676-.67 1.746 1.7zM1.012 8.5v-1h2.462v1zm2.4 4.807-.697-.725 1.72-1.72.361.342.368.351zm4.59-1.64q-1.528 0-2.598-1.07-1.07-1.069-1.07-2.596t1.068-2.597 2.596-1.07 2.598 1.068q1.07 1.07 1.07 2.596t-1.069 2.598q-1.069 1.07-2.596 1.07m-.002-1q1.1 0 1.883-.784.784-.783.784-1.883t-.784-1.883A2.57 2.57 0 0 0 8 5.333q-1.1 0-1.883.784A2.57 2.57 0 0 0 5.333 8q0 1.1.784 1.883.783.784 1.883.784"
  })));
};
export default SvgIconBrightness;